import React, { useContext, useEffect } from 'react';
import { View } from 'dripsy';
import { useAtom } from 'jotai';
import { CachoeirasProps } from '../../navigation/types';
import { localAtom } from '../../atoms';
import { LanguageContext } from '../../context/LanguageContext';
import { CIDADE } from '../../values/constants';
import ServiceAlone from '../../components/ServiceAlone';

const Cachoeiras: React.FC<CachoeirasProps> = ({ navigation }) => {
  const [local] = useAtom(localAtom);
  const [{ strings: str }] = useContext(LanguageContext);

  useEffect(() => {
    navigation.setOptions({
      headerTitle: `${CIDADE[local]} / ${str.cachoeiras}`
    });
  }, [navigation, local, str]);

  return (
    <View sx={{ flex: 1 }}>
      <ServiceAlone repo='Lugares' tipo='cachoeiras' />
    </View>
  );
};

export default Cachoeiras;
